import { Box } from "@chakra-ui/react"
import * as React from "react"
import { useRecoilValue } from "recoil"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { LogoOverlay } from "../../logo-overlay"
import { MobileHeaderProps } from "./mobile-header.interface"

const _MobileHeader: React.FC<MobileHeaderProps> = ({
  isLandscape,
  width,
  isVideoHeader,
  isSafari
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isOpen } = useRecoilValue(productOverlaySelector)
  const isLogo = React.useMemo(() => {
    if (
      roomStyles?.showMobileLogo &&
      roomStyles?.mobileLogo &&
      !isOpen
    ) {
      return true
    }
    return false
  }, [isOpen, roomStyles?.mobileLogo, roomStyles?.showMobileLogo])

  return (
    <>
      <Box w={width} top="0" id="header-avatar3">
        <Box
          position={isVideoHeader ? "absolute" : "fixed"}
          zIndex="tooltip"
          id="header-avatar"
          pt="10px"
          top="10px"
          left={isLandscape && isSafari ? "40px" : "10px"}
          boxSize="30px"
          className="logo"
        >
          {isLogo && (
            <LogoOverlay isMobile={true} src={roomStyles?.mobileLogo} />
          )}
        </Box>
      </Box>
    </>
  )
}

export const MobileHeader = React.memo(_MobileHeader)
